function e(t = 1) {
  return {
    gutter: 16 * t
  };
}
export {
  e as default
};
//# sourceMappingURL=layout.js.map
